import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('PROVIDER_CATALOG', ['FORM_CATALOG'])
